import Button from "@components/_Revamp/Button";
import HealthMainContainer from "@components/_Revamp/HealthMainContainer";
import InnerContainer from "@components/_Revamp/InnerContainer";
import { css } from "@linaria/core";
import { useAvivaDispatch, useAvivaSelector } from "@redux/hook";
import { updateUnderWtiting3 } from "@redux/slices/CCP/step3Slice";
import { ROUTE_PATH } from "@static/route-paths";
import { SCREEN_SIZE } from "@static/screen-size";
import React, { useEffect, useLayoutEffect, useState } from "react";
import Modal from "@components/_Revamp/Modal";
import { Title } from "@components/_Revamp/Typography/Title.stories";
import { themeDefault } from "src/theme-revamp";
import { useHistory } from "react-router-dom";
import { Tooltip } from "@pages/CCP/components/Tooltip";
import { store } from "@redux/store";
import { trackOnCTA, trackOnLoad } from "@pages/CCP/Helpers/analyticsHelper";
import { CCP_STEP_LIST } from "@static/content";
import { ContainerWithStepper } from "@pages/CCP/components/ContainerWithStepper";

function UnderWriting3() {
  const uw3 = useAvivaSelector(
    (state) => state.cancerCoverStep3.underWriting3.hasSymptomsinSixMonths
  );
  const dispatch = useAvivaDispatch();
  const history = useHistory();
  const [showModal, setShowModal] = useState<boolean>();
  const basicInfo = useAvivaSelector(
    (state) => state.cancerCoverStep1.basicInfo
  );

  useLayoutEffect(() => {
    if (
      store.getState().cancerCoverStep3.underWriting3.hasSymptomsinSixMonths ===
      null
    ) {
      dispatch(updateUnderWtiting3("NO"));
    }
  }, []);

  //AA Page Loading
  useEffect(() => {
    trackOnLoad();
  }, []);

  useEffect(() => {
    if (showModal) {
      trackOnLoad();
    }
  }, [showModal]);

  return (
    <>
      <ContainerWithStepper
        currentStep={ROUTE_PATH.CANCER_COVER_UW_1A}
        className={containerStyle}
        backButtonPath={ROUTE_PATH.CANCER_COVER_UW_2}
      >
        <InnerContainer className={uw3style}>
          <h3>
            {basicInfo?.forwhom === "myself"
              ? "In the past 6 months, have you had any of these symptoms?"
              : "In the past 6 months, has your child had any of these symptoms?"}
          </h3>
          <section>
            <ul>
              <li>
                a){" "}
                <Tooltip title={"Unexplained weight loss"} isFixed={true}>
                  <span>
                    It is when you lose weight without changing your diet or
                    exercise routine.
                  </span>
                </Tooltip>{" "}
                of 5 kg or more; or{" "}
              </li>
              <li>b) Coughing with blood; or </li>
              <li>
                c) Unusual bleeding or discharge from any body part for more
                than one week continuously; or{" "}
              </li>
              <li>d) Persistent change in bowel or bladder habits; or </li>
              <li>e) A mole or skin blemish which has changed in appearance</li>
            </ul>
          </section>
          <div>
            <Button
              disabled={false}
              label={"Yes, at least one"}
              hoverBgColor={themeDefault.colors.primary}
              bgColor={uw3 === "YES" ? themeDefault.colors.primary : "#F5F5F5"}
              borderColor="none"
              textColor={uw3 === "YES" ? "#FFFFFF" : "#8A8988"}
              onClick={() => {
                dispatch(updateUnderWtiting3("YES"));
              }}
              width=""
            />
            <Button
              disabled={false}
              label={"No, none of the above"}
              hoverBgColor={themeDefault.colors.primary}
              bgColor={uw3 === "NO" ? themeDefault.colors.primary : "#F5F5F5"}
              textColor={uw3 === "NO" ? "#FFFFFF" : "#8A8988"}
              borderColor="none"
              onClick={() => {
                dispatch(updateUnderWtiting3("NO"));
              }}
            />
          </div>
        </InnerContainer>
        <div className={`next-btn`}>
          <Button
            label={"Next"}
            hoverBgColor={themeDefault.colors.primary}
            onClick={() => {
              if (uw3 === "NO") {
                history.push(ROUTE_PATH.CANCER_COVER_USER_DECLARATION);
                trackOnCTA({ ctaText: "Next", ctaType: "qb:link" });
              } else {
                setShowModal(() => {
                  trackOnLoad();
                  return true;
                });
              }
            }}
          />
        </div>
      </ContainerWithStepper>
      {showModal && (
        <Modal
          show={showModal}
          className={modalStyle}
          onClose={() => {
            setShowModal(false);
          }}
        >
          <Title variant="title" align="center">
            You may need some assistance
          </Title>
          <p>
            It looks like you might need assistance from a Financial Adviser
            Representative to find a more suitable plan for your needs.
          </p>
          <div>
            <Button
              disabled={false}
              label={"Contact us"}
              onClick={() => {
                history.push(ROUTE_PATH.CANCER_COVER_CONTACT_US);
                trackOnCTA({ ctaText: "Contact Us", ctaType: "qb:link" });
              }}
            />
          </div>
        </Modal>
      )}
    </>
  );
}

export default UnderWriting3;

const modalStyle = css`
  .modal-body {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 16px;
    & > div {
      width: 100%;
    }
  }
  p:nth-child(2) {
    color: #8a8988;
    font-size: 14px;
    font-weight: 600;
    text-align: center;
    line-height: 19.6px;
    margin-bottom: 48px;
  }

  button {
    width: 100%;
    font-weight: 600;
    font-size: 16px;
    letter-spacing: 1.28px;
    line-height: 22.4px;
  }

  @media screen and (min-width: ${SCREEN_SIZE.mobilesUp}px) {
    .modal-body {
      & > div {
        max-width: 180px;
        width: 100%;
      }
    }
    button {
      max-width: 180px;
    }
  }
`;

const containerStyle = css`
  .next-btn {
    display: flex;
    justify-content: center;
    button {
      /* max-width: 200px; */
    }
  }

  .disabledBtn {
    button {
      background-color: #d4bfd7;
      color: #f7f9fb;
    }
  }

  @media screen and (min-width: ${SCREEN_SIZE.mobilesUp}px) {
    .next-btn {
      button {
        max-width: 200px;
      }
    }
  }
`;
const uw3style = css`
  display: flex;
  gap: 36px;
  flex-direction: column;
  color: #434343;
  margin-bottom: 48px;
  h3 {
    font-size: 18px;
    font-weight: 600;
    line-height: 25.2px;
    letter-spacing: 0.27px;
  }
  section {
    ul {
      list-style: none;
      font-size: 14px;
      font-weight: 500;

      display: flex;
      flex-direction: column;
      gap: 16px;
    }
  }
  div {
    display: flex;
    gap: 8px;
    flex-direction: column;
    justify-content: center;

    button {
      max-width: 328px;
      font-size: 14px;
    }
  }

  @media screen and (min-width: ${SCREEN_SIZE.mobilesUp}px) {
    padding: 24px 64px;

    div {
      flex-direction: row;
      button {
        font-size: 12px;
      }
    }
  }
`;
